import { lazy } from "react";
import { RouteObject, Outlet } from "react-router-dom";
import { PROFILE_URL } from "profile/constants/url";
import LazyLoader from "base/components/LazyLoader";

const ProfilePage = LazyLoader(lazy(() => import("profile/pages/ProfilePage")));

const route: RouteObject = {
  path: PROFILE_URL,
  element: <ProfilePage />,
};

export default route;
